import React, { useEffect } from "react";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import LayoutWithDataContainer from "../../containers/LayoutWithDataContainer";
import ProductModal from "./components/ProductModal/ProductModal";
import QuoteBuilder from "./components/QuoteBuilder/QuoteBuilder";
import ShopWrapper from "./components/ShopWrapper/ShopWrapper";
import QuoteContainer from "./containers/QuoteContainer/QuoteContainer";
import PricingContainer from "./containers/PricingContainer/PricingContainer";
import { getSupplierData } from "../../Redux/Selectors/appConfigSelector";
import {
  clickEvents,
  registerSuperProperties,
  trackEvent,
} from "../../services/mixpanel";
import usePeriod from "../../hooks/usePeriod";
import BannerRenderContainer from "../../components/BannerComponent/BannerRenderContainer";
import { Container } from "./ShopPageScreen.styles";
import { BANNER_PAGE } from "../ExperiencesPage/list/helpers/constants";

const ShopPageScreen = ({ isModalVisible, handleOnDismissModal, isIframe }) => {
  usePeriod();
  const { t } = useTranslation();
  const supplierData = useSelector(getSupplierData);

  useEffect(() => {
    registerSuperProperties({
      isIframe,
    });
    trackEvent(clickEvents.OPEN_PAGE, {
      page: "ShopPage",
      supplier: supplierData.name,
      supplierId: supplierData._id,
    });
  }, []);

  const renderProductModal = () => {
    return (
      <ProductModal visible={isModalVisible} onClose={handleOnDismissModal} />
    );
  };

  return (
    <LayoutWithDataContainer isIframe={isIframe}>
      <Container>
        <PricingContainer>
          {({
            pricingData,
            isPricingFetching,
            discount: {
              handleApplyDiscount,
              handleRemoveDiscount,
              discountError,
            },
          }) => {
            const discountsProps = {
              onApplyDiscount: handleApplyDiscount,
              onRemoveDiscount: handleRemoveDiscount,
              discountError,
            };
            return (
              <QuoteContainer>
                {({
                  productsByCategory,
                  categories,
                  handleOnSubstractProduct,
                  handleOnAddProduct,
                  quoteSummary,
                  daysQuantity,
                  toDate,
                  searchName,
                  itemsLength,
                  isProductsFetching,
                  handleOnDetailsClick,
                  handleOnDismissModal,
                  supplierData,
                  activities,
                  selectedProducts,
                  isModalVisible,
                  handleOnSummaryClick,
                  dates,
                  showPickUpAndDropOffModal,
                  handleShowPickUpAndDropOffModal,
                }) => {
                  return (
                    <ShopWrapper
                      renderExtra={() =>
                        renderProductModal(isModalVisible, handleOnDismissModal)
                      }
                      itemsLength={itemsLength}
                      pricingData={pricingData}
                      quoteSummary={quoteSummary}
                      selectedProducts={selectedProducts}
                      isPricingFetching={isPricingFetching}
                      handleOnSummaryClick={handleOnSummaryClick}
                      buttonLabel={t("continue")}
                      dates={dates}
                      discounts={discountsProps}
                      handleShowPickUpAndDropOffModal={
                        handleShowPickUpAndDropOffModal
                      }
                      showPickUpAndDropOffModal={showPickUpAndDropOffModal}
                    >
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          padding: 20,
                          backgroundColor: "white",
                          gap: 10,
                        }}
                      >
                        <BannerRenderContainer
                          screen={BANNER_PAGE.productsScreen}
                        />
                      </div>
                      <QuoteBuilder
                        productsByCategory={productsByCategory}
                        categories={categories}
                        supplierData={supplierData}
                        handleOnAddProduct={handleOnAddProduct}
                        handleOnSubstractProduct={handleOnSubstractProduct}
                        quoteSummary={quoteSummary}
                        daysQuantity={daysQuantity}
                        toDate={toDate}
                        isProductsFetching={isProductsFetching}
                        handleOnDetailsClick={handleOnDetailsClick}
                        activities={activities}
                        visible={!isProductsFetching}
                        pricingData={pricingData}
                        isPricingFetching={isPricingFetching}
                        itemsLength={itemsLength}
                        selectedProducts={selectedProducts}
                        handleOnSummaryClick={handleOnSummaryClick}
                        searchName={searchName}
                        dates={dates}
                        discounts={discountsProps}
                        handleShowPickUpAndDropOffModal={
                          handleShowPickUpAndDropOffModal
                        }
                        showPickUpAndDropOffModal={showPickUpAndDropOffModal}
                      />
                      <ProductModal
                        visible={isModalVisible}
                        onClose={handleOnDismissModal}
                      />
                    </ShopWrapper>
                  );
                }}
              </QuoteContainer>
            );
          }}
        </PricingContainer>
      </Container>
    </LayoutWithDataContainer>
  );
};

export default ShopPageScreen;
